import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import URLS from "redux/urls";
import request from "redux/utils/request";

export const fetchAllVideo = createAsyncThunk(
  "Video/fetchAllVideo",
  async (params, { rejectWithValue }) => {
    try {
      const response = await request("get", URLS.GALLERY, {
        type: "video",
        ...params,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchAllImage = createAsyncThunk(
  "Image/fetchAllImage",
  async (params, { rejectWithValue }) => {
    try {
      const response = await request("get", URLS.GALLERY, {
        type: "image",
        ...params,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addVideo = createAsyncThunk(
  "Video/addVideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request("post", URLS.GALLERY, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateVideo = createAsyncThunk(
  "Video/updateVideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request(
        "patch",
        `${URLS.GALLERY}/${payload.id}`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchOneImage = createAsyncThunk(
  "Image/fetchOneImage",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("get", `${URLS.GALLERY}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchOneVideo = createAsyncThunk(
  "Video/fetchOneVideo",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("get", `${URLS.GALLERY}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteVideo = createAsyncThunk(
  "Video/deleteVideo",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("delete", `${URLS.GALLERY}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteImage = createAsyncThunk(
  "Image/deleteImage",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("delete", `${URLS.GALLERY}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loading: {
    query: false,
    mutation: false,
  },
  filter: {
    q: "",
  },
  list: [],
  count: {},
  selected: {},
  selectedRows: [],
};

const loadingReducer = (fieldName, status) => (state) => {
  state.loading[fieldName] = status;
};

const startLoadingQuery = loadingReducer("query", true);
const stopLoadingQuery = loadingReducer("query", false);
const startLoadingMutation = loadingReducer("mutation", true);
const stopLoadingMutation = loadingReducer("mutation", false);

export const VideoSlice = createSlice({
  name: "Video",
  initialState,
  reducers: {
    setAppliedSearchText: (state, action) => {
      state.filter.q = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllVideo.pending, startLoadingQuery)
      .addCase(fetchAllVideo.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading.query = false;
      })
      .addCase(fetchAllVideo.rejected, stopLoadingQuery);
    builder
      .addCase(fetchAllImage.pending, startLoadingQuery)
      .addCase(fetchAllImage.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading.query = false;
      })
      .addCase(fetchAllImage.rejected, stopLoadingQuery);
    builder
      .addCase(fetchOneVideo.pending, startLoadingQuery)
      .addCase(fetchOneVideo.rejected, stopLoadingQuery)
      .addCase(fetchOneVideo.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(fetchOneImage.pending, startLoadingQuery)
      .addCase(fetchOneImage.rejected, stopLoadingQuery)
      .addCase(fetchOneImage.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(updateVideo.pending, startLoadingQuery)
      .addCase(updateVideo.rejected, stopLoadingQuery)
      .addCase(updateVideo.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(deleteVideo.pending, startLoadingMutation)
      .addCase(deleteVideo.fulfilled, stopLoadingMutation)
      .addCase(deleteVideo.rejected, stopLoadingMutation);
  },
});

export const { setSelectedRows, setAppliedSearchText } = VideoSlice.actions;

export default VideoSlice.reducer;
